<template>
    <b-card title="Filtros" class="d-print-none">
        <div class="filter-container  d-flex align-items-end">
            <div>
                <app-date-picker 
                    label="Desde"
                    :value="startDate"
                    :with-time="false"
                    @change="value => handleStartDateChange(value)"
                />
            </div>
            <div class="ml-4">
                <app-date-picker 
                    label="Hasta"
                    :value="endDate"
                    :with-time="false"
                    @change="value => handleEndDateChange(value)"
                />
            </div>
            <div class="ml-4">
                <b-button variant="primary" @click="onFilter"><i class="fa fa-filter"></i></b-button>
            </div>
            <div class="ml-4">
                <b-button variant="primary" @click="print"><i class="fa fa-print"></i></b-button>
            </div>
        </div>
    </b-card>
</template>
<script>
import DatePicker from '../../../../UI/Controls/DateTimePicker/DateTimePicker.vue';
export default {
    components: {
        appDatePicker: DatePicker
    },
    props: ['startDate', 'endDate', 'handleStartDateChange', 'handleEndDateChange', 'onFilter'],
    methods: {
        print(){
            window.print();
        }
    }
}
</script>